<template>
  <modal :value="isOpen" title="Change Details" @click:outside="closeModal">
    <template #buttons>
      <qvoButton text @click="closeModal">Cancel</qvoButton>
      <qvoButton @click="saveChanges" :disabled="!isFormValid">Save</qvoButton>
    </template>
    <div class="content">
      <commitData
        :title="item.ChangeTitle"
        :details="item.ChangeDetails"
        @setIsFormValid="setIsFormValid"
        @setTitle="setTitle"
        @setDetails="setDetails"
      />
      <div v-if="item.RestoreToVersion">
        Restored to Version {{ item.RestoreToVersion }}
      </div>
      <updatedValuesSummary :updatedValues="item.Changes" />
    </div>
  </modal>
</template>
  
<script>
import modal from "@/qux-common/qux22/components/molecules/modal";
import qvoButton from "@/qux-common/qux22/components/molecules/button";

import commitData from "@/components/commit-data";
import updatedValuesSummary from "@/components/updated-values-summary";

export default {
  components: {
    commitData,
    modal,
    qvoButton,
    updatedValuesSummary,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isFormValid: false,
      details: undefined,
      title: undefined,
    };
  },
  methods: {
    setIsFormValid(value) {
      this.isFormValid = value;
    },
    setTitle(title) {
      this.title = title;
    },
    setDetails(details) {
      this.details = details;
    },
    saveChanges() {
      this.$emit("editChange", {
        ChangeTitle:
          this.title === undefined ? this.item.ChangeTitle : this.title,
        ChangeDetails:
          this.details === undefined ? this.item.ChangeDetails : this.details,
      });
      this.closeModal();
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
  
<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: $qvo-spacing-24;
}
</style>